import http from "../../backend/http.js";

async function getProduct(id) {
  try {
    const response = await http.get(`sales/products/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      unit: response.data.unit ? {
        id: response.data.unit.id,
        title: response.data.unit.title,
      } : null,
      fullTitle: response.data.fullTitle,
      pictures: response.data.pictures,
      siteTitle: response.data.siteTitle,
    };
  } catch (err) {
    throw err;
  }
}

async function updateProduct(id, data) {
  try {
    const response = await http.put(`sales/products/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createProduct(data) {
  try {
    const response = await http.post("sales/products", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProducts(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/products?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function deleteProductPicture(productId, pictureId) {
  try {
    const response = await http.delete(`sales/products/${productId}/pictures/${pictureId}`);
    return response;
  } catch (err) {
    throw err;
  }
}

async function uploadImages(productId, formData) {
  const response = await http.post(`sales/products/${productId}/pictures`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

async function getProductReferences(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/products/references?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getProduct, updateProduct, getProducts, createProduct, deleteProductPicture, uploadImages, getProductReferences };